import React, { useContext, useEffect, useRef, useState } from 'react';
import ViewerContext from '../../context/ViewerContext';
import './timeLine.css'
import TimeLineBarComponent from './TimeLineBarComponent';
import LineChart from '../timeChart/LineChart';

const TimeLineComponent = () => {

    const { igcParsedData } = useContext(ViewerContext);


    useEffect(() => {
        if (igcParsedData.length > 0) {
            //use igcparser data to create chart
            console.log(igcParsedData)

        }
    }, [igcParsedData]);

    return (
        <div className="timeline-container no-select-item">
            <LineChart/>
            <TimeLineBarComponent />

        </div>
    );
};

export default TimeLineComponent;
